<template>
  <div>
    <dialog-loading v-if="saving" loadingText="Salvando"></dialog-loading>
    <card-loading-transparent v-if="loading"></card-loading-transparent>
    <v-form class="mx-5" ref="form_info" v-if="!loading">

      <v-row class="pa-0" style="position: relative; top: -51px; left: 34px">
        <v-col cols='12' class="mx-2 d-flex justify-end">
          <v-btn v-if="is_editing" small dense text class="mx-2 btn-error" align="center" @click="$emit('cancelEditing')">
            <v-icon left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-btn v-if="is_editing" small dense text class="mx-2 btn-success" align="center" @click="updateEvent">
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pa-0">
          <v-text-field dense outlined v-model="event.name" label="Nome do bloqueio" :rules="required"
            class="mt-n7"></v-text-field>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on" tile :color="event.color || 'primary'" elevation="4"
                class="white--text" dense>
                <v-icon color="white"> mdi-brush </v-icon>
                Cor do bloqueio na agenda
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <calendar-color-picker is_color_existe :color_prop="event.color"
                  @color='handleColor'></calendar-color-picker>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" class="pa-0 mt-3">
          <v-card outlined>
            <v-card-title class="v-picker__title py-1">
              <div class="text-subtitle-1 font-weight-bold">{{ formatDateToShow }}</div>
            </v-card-title>
            <v-card-text class="px-0 pb-3">
              <v-date-picker v-model="dates" @change="sortDates" range full-width no-title
                style="border-radius: 0px;"></v-date-picker>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col class="px-0 pt-0">
          <div :class="$vuetify.breakpoint.mobile ? 'py-3' : 'd-flex mt-3'">
            <div>
              <v-menu :offset-y="true" :offset-x="false" nudge-left="50" :close-on-content-click="false"
                v-model="menu_start_time">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" small min-width="280" label class="background-color-def" dark>
                    <v-icon left>mdi-clock-outline</v-icon>
                    {{ event.start_time ? 'INÍCIO' : 'DEFINIR HORARIO DE INÍCIO' }} <b class="ml-1">{{ event.start_time
                    }}</b>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text class="pa-0">
                    <v-time-picker format="24hr" v-model="event.start_time"></v-time-picker>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="menu_start_time = false">fechar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
            <div :class="$vuetify.breakpoint.mobile ? 'mt-3' : 'ml-3'">
              <v-menu :offset-y="true" :offset-x="false" nudge-left="50" :close-on-content-click="false"
                v-model="menu_end_time">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" small min-width="280px" label class="background-color-def" dark><v-icon
                      left>mdi-clock-outline</v-icon>
                    {{ event.end_time ? 'TÉRMINO' : 'DEFINIR HORARIO DE TÉRMINO' }} <b class="ml-1"> {{ event.end_time
                    }}</b>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text class="pa-0">
                    <v-time-picker format="24hr" v-model="event.end_time"></v-time-picker>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="menu_end_time = false">fechar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import Api from '@/api/index'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'EditScheduleBlock',
  mixins: [validations],
  components: {
    CalendarColorPicker: () => import('../../calendar/CalendarColorPicker.vue'),
  },
  props: {
    is_editing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      saving: false,
      menu_start_time: false,
      menu_end_time: false,
      menu_data: false,
      dates: [],
      event: {}
    }
  },
  methods: {
    setDate() {
      this.loading = true
      Api.Event.show(this.$route.params.id).then((r) => this.event = r.data).then(() => {
        this.dates[0] = this.$dayjs(this.event.start_at).format('YYYY-MM-DD')
        this.dates[1] = this.$dayjs(this.event.end_at).format('YYYY-MM-DD')
        this.event.start_time = this.$dayjs(this.event.start_at).format('HH:mm')
        this.event.end_time = this.$dayjs(this.event.end_at).format('HH:mm')
      }).finally(() => {
        this.loading = false
      })
    },
    sortDates() {
      return this.dates.sort()
    },
    updateEvent() {
      if (!this.validateForm()) {
        this.swallConfirmation({ msg: 'Certifique-se de preencher todos os campos e datas', icon: 'error' })
      } else if ((this.event.end_time < this.event.start_time) && this.dates.length <= 1) {
        this.swallConfirmation({ msg: 'O Horario de início não pode ser maior que o término', icon: 'error' })
      } else {
        this.swallConfirmation({ msg: 'Deseja realizar tarefa?', icon: 'question' }).then(r => {
          if (r && this.validateForm()) {
            this.saving = true

            let start_of = this.$dayjs(`${this.dates[0]} ${this.event.start_time}`)
            let end_of = this.dates.length > 1 ? this.$dayjs(`${this.dates[1]} ${this.event.end_time}`) : this.$dayjs(`${this.dates[0]} ${this.event.end_time}`)

            let event = {
              id: this.$route.params.id,
              name: this.event.name,
              start_at: start_of,
              end_at: end_of,
              start_time: start_of,
              end_time: end_of,
            }
            Api.Event.update(event).then(r => {

              this.addNotification({ msg: 'Atualizado com sucesso', type: 'success' })
            }).catch((err) => {
              let throw_msg = 'Ops, Ocorreu um erro'
              if (err.response.data.start_at) {
                throw_msg = err.response.data.start_at[0]
              }
              this.addNotification({ msg: throw_msg, type: 'error' })
            }).finally(() => {
              this.saving = false
            })
          }
        })
      }
    },
    swallConfirmation(data) {
      return this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        title: data.msg,
        icon: data.icon, //[ success, error, warning, info, question]
      }).then(r => {
        return r.value
      });
    },
    handleColor(v) {
      this.event.color = v
    },
    validateForm() {
      return this.$refs.form_info.validate()
    },

    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  computed: {
    formatDateToShow() {
      if (this.dates.length > 0) {
        let is_same = this.dates.length > 1 ? this.$dayjs(this.dates[0]).isSame(this.dates[1], 'day') : true

        let s_date = this.$dayjs(this.dates[0]).format(`DD/MM/YYYY [às] [${this.event.start_time}]`)
        let e_date = is_same ? this.event.end_time : this.$dayjs(this.dates[1]).format(`DD/MM/YYYY [até as] [${this.event.end_time}]`)

        return s_date + ' a ' + e_date
      } else {
        return this.$dayjs(this.event.start_at).isSame(this.event.end_at, 'day') ?
          this.$dayjs(this.event.start_at).format(`DD/MM/YYYY [às] [${this.event.start_time}]`) +
          this.event.end_time
          :
          this.$dayjs(this.event.start_at).format(`DD/MM/YYYY [às] [${this.event.start_time}]`) +
          this.$dayjs(this.event.end_at).format(`DD/MM/YYYY [às] [${this.event.end_time}]`)
      }
    },

  },
  mounted() {
    this.setDate()
  },
}
</script>

<style scoped>
>>>.v-date-picker-title__date {
  font-size: 16px !important;
}

>>>.v-picker__title {
  background-color: #82b1ff !important;
}

>>>.v-date-picker-title__date {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

>>>.v-application .primary {
  background-color: #000000 !important;
}

>>>.v-application .primary {
  background-color: #000000 !important;
}

.background-color-def {
  background-color: #82b1ff !important;
}
</style>